import { IViewUserModel,INewUser, IUserProfile } from '../interfaces/';

export class ViewUserModel implements IViewUserModel {
    user: INewUser;
    profile: IUserProfile;
}


// WEBPACK FOOTER //
// ./src/app/models/ViewUserModel.ts